/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this file will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Make showDescription globally accessible
  window.showDescription = function (eventId) {
    console.log("Event clicked: " + eventId);

    // Remove 'active' class from all timeline blocks and descriptions
    var blocks = document.querySelectorAll('.timeline-block-horizontal');
    blocks.forEach(function (block) {
      block.classList.remove('active');
    });

    var descriptions = document.querySelectorAll('.description-content');
    descriptions.forEach(function (desc) {
      desc.classList.remove('active');
    });

    // Add 'active' class to the clicked description
    document.getElementById(eventId).classList.add('active');

    // Add 'active' class to the corresponding timeline block
    var activeBlock = document.querySelector(`[onclick="showDescription('${eventId}')"]`);
    if (activeBlock) {
      activeBlock.classList.add('active');
    }
  };

  // Horizontal scroll via dragging
  const timelineContainer = document.querySelector('.timeline-container-horizontal');

  if (timelineContainer) {
    let isDown = false;
    let startX;
    let scrollLeft;

    timelineContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      timelineContainer.classList.add('active');
      startX = e.pageX - timelineContainer.offsetLeft;
      scrollLeft = timelineContainer.scrollLeft;
    });

    timelineContainer.addEventListener('mouseleave', () => {
      isDown = false;
      timelineContainer.classList.remove('active');
    });

    timelineContainer.addEventListener('mouseup', () => {
      isDown = false;
      timelineContainer.classList.remove('active');
    });

    timelineContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - timelineContainer.offsetLeft;
      const walk = (x - startX) * 2;
      timelineContainer.scrollLeft = scrollLeft - walk;
    });

    // Touch events
    timelineContainer.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX - timelineContainer.offsetLeft;
      scrollLeft = timelineContainer.scrollLeft;
    });

    timelineContainer.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX - timelineContainer.offsetLeft;
      const walk = (x - startX) * 2;
      timelineContainer.scrollLeft = scrollLeft - walk;
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
